import { useNavigate, useLocation } from "react-router-dom";
import { useRef, useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { t } from "../i18n";
import LangDropdown from "./LangDropdown";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [roomOpen,    setRoomOpen]    = useState(false);
  const [receiptOpen, setReceiptOpen] = useState(false);
  const [reportOpen,  setReportOpen]  = useState(false);
  const [menuOpen,    setMenuOpen]    = useState(false);
  const dropRef        = useRef(null);
  const receiptDropRef = useRef(null);
  const reportDropRef  = useRef(null);
  const { lang } = useLanguage();

  const isActive = (path) => location.pathname === path;

  // ปิดเมนูมือถือเมื่อเปลี่ยนหน้า
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const go = (path) => {
    navigate(path);
    setMenuOpen(false);
  };
  const isRoomGroup = [
    "/admin/booking", "/admin/rooms", "/admin/calendar",
    "/admin/cancellations", "/admin/checkin", "/admin/checkout",
    "/admin/payments",
  ].includes(location.pathname);

  useEffect(() => {
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) setRoomOpen(false);
      if (receiptDropRef.current && !receiptDropRef.current.contains(e.target)) setReceiptOpen(false);
      if (reportDropRef.current && !reportDropRef.current.contains(e.target)) setReportOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const roomItems = [
    { labelKey: "roomBooking",  path: "/admin/booking",       icon: iconBed() },
    { labelKey: "roomManage",   path: "/admin/rooms",         icon: iconGrid() },
    { labelKey: "roomDetail",   path: "/admin/calendar",      icon: iconList() },
    { labelKey: "cancelReq",    path: "/admin/cancellations", icon: iconBan() },
    { labelKey: "checkIn",      path: "/admin/checkin",       icon: iconIn() },
    { labelKey: "checkOut",     path: "/admin/checkout",      icon: iconOut() },
    { labelKey: "verifySlip",   path: "/admin/payments",      icon: iconSlip() },
  ];

  return (
    <>
      <style>{`
        .anav {
          background: #fff;
          box-shadow: 0 2px 8px rgba(0,0,0,.08);
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 60px;
          position: sticky;
          top: 0;
          z-index: 1000;
          font-family: 'Noto Sans Thai', sans-serif;
          font-size: 13.5px;
        }
        .anav-brand {
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
        }
        .anav-logo {
          width: 40px; height: 40px;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .anav-logo img { width: 100%; height: 100%; object-fit: contain; }
        .anav-title { font-size: 14px; font-weight: 700; color: #1a1a1a; white-space: nowrap; }
        .anav-badge {
          display: inline-block;
          background: #374151; color: #fff;
          font-size: 10px; font-weight: 700;
          padding: 1px 7px; border-radius: 99px;
          margin-left: 6px; vertical-align: middle;
          letter-spacing: .5px;
        }
        .anav-right { display: flex; align-items: center; gap: 2px; }
        .anav-btn {
          display: flex; align-items: center; gap: 5px;
          padding: 5px 10px; border-radius: 7px;
          font-size: 13px; font-weight: 500; color: #374151;
          background: none; border: none; cursor: pointer;
          white-space: nowrap; transition: background .15s, color .15s;
          font-family: 'Noto Sans Thai', sans-serif;
        }
        .anav-btn:hover { background: #f3f4f6; color: #111; }
        .anav-btn.active { background: #eff6ff; color: #1d4ed8; }
        .anav-btn.room-active { background: #eff6ff; color: #1d4ed8; }
        .anav-dropdown-wrap { position: relative; }
        .anav-dropdown {
          position: absolute; top: calc(100% + 6px); left: 0;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          box-shadow: 0 8px 24px rgba(0,0,0,.10);
          min-width: 170px;
          padding: 4px 0;
          z-index: 999;
        }
        .anav-drop-item {
          display: flex; align-items: center; gap: 8px;
          padding: 9px 14px;
          font-size: 13px; font-weight: 500; color: #374151;
          background: none; border: none; cursor: pointer;
          width: 100%; text-align: left;
          white-space: nowrap;
          transition: background .12s, color .12s;
          font-family: 'Noto Sans Thai', sans-serif;
        }
        .anav-drop-item:hover { background: #f3f4f6; color: #111; }
        .anav-drop-item.active { background: #eff6ff; color: #1d4ed8; }
        .anav-drop-item.cancel-item:hover { background: #fff1f1; color: #991b1b; }
        .anav-drop-item.cancel-item.active { background: #fee2e2; color: #991b1b; }
        .anav-drop-item.slip-item:hover { background: #f0fdf4; color: #065f46; }
        .anav-drop-item.slip-item.active { background: #dcfce7; color: #065f46; }
        .anav-drop-divider { height: 1px; background: #f3f4f6; margin: 4px 0; }
        .anav-logout {
          display: flex; align-items: center; gap: 5px;
          padding: 5px 10px; border-radius: 7px;
          font-size: 13px; font-weight: 600; color: #dc2626;
          background: none; border: none; cursor: pointer;
          white-space: nowrap; transition: background .15s;
          font-family: 'Noto Sans Thai', sans-serif;
        }
        .anav-logout:hover { background: #fff1f1; }
        .anav-status-dot {
          width: 7px; height: 7px; border-radius: 50%;
          background: #22c55e; display: inline-block; margin-right: 2px;
          animation: anav-pulse 2s infinite;
        }
        @keyframes anav-pulse {
          0%,100% { box-shadow: 0 0 0 0 rgba(34,197,94,.4); }
          50%      { box-shadow: 0 0 0 5px rgba(34,197,94,0); }
        }

        /* ── Hamburger (ซ่อนบนจอใหญ่) ── */
        .anav-hamburger {
          display: none;
          background: none; border: none; cursor: pointer;
          padding: 8px; border-radius: 8px; color: #374151;
        }
        .anav-hamburger:hover { background: #f3f4f6; }

        /* ── Responsive ── */
        @media (max-width: 1024px) {
          .anav { padding: 0 14px; }
          .anav-hamburger { display: flex; align-items: center; justify-content: center; }
          .anav-right {
            position: fixed;
            top: 60px; left: 0; right: 0;
            flex-direction: column;
            align-items: stretch;
            gap: 2px;
            background: #fff;
            padding: 8px;
            box-shadow: 0 10px 20px rgba(0,0,0,.12);
            border-top: 1px solid #f1f5f9;
            max-height: calc(100vh - 60px);
            overflow-y: auto;
            transform: translateY(-130%);
            transition: transform .25s ease;
            visibility: hidden;
          }
          .anav-right.open { transform: translateY(0); visibility: visible; }
          .anav-btn, .anav-logout {
            width: 100%;
            justify-content: flex-start;
            padding: 12px 14px;
            font-size: 15px;
            border-radius: 8px;
          }
          .anav-dropdown-wrap { width: 100%; }
          /* ทำให้ dropdown กลายเป็น accordion */
          .anav-dropdown {
            position: static;
            box-shadow: none;
            border: none;
            border-radius: 0;
            min-width: 0;
            padding: 2px 0 2px 16px;
          }
          .anav-drop-item { padding: 11px 14px; font-size: 14px; border-radius: 8px; }
        }
      `}</style>

      <nav className="anav">
        {/* Brand */}
        <div className="anav-brand" onClick={() => navigate("/admin")}>
          <div className="anav-logo"><img src="/logo-mark.png" alt="logo" /></div>
          <span className="anav-title">
            Eurngkam
            <span className="anav-badge">Admin</span>
          </span>
        </div>

        {/* Hamburger (มือถือ) */}
        <button
          className="anav-hamburger"
          onClick={() => setMenuOpen((p) => !p)}
          aria-label="menu"
        >
          {menuOpen ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          )}
        </button>

        {/* Right */}
        <div className={`anav-right ${menuOpen ? "open" : ""}`}>

          {/* แดชบอร์ด */}
          <button
            className={`anav-btn ${isActive("/admin") ? "active" : ""}`}
            onClick={() => go("/admin")}
          >
            {iconHome()} {t(lang, "dashboard")}
          </button>

          {/* ✅ สถานะ (เหมือน staff) */}
          <button
            className={`anav-btn ${isActive("/statuspage") ? "active" : ""}`}
            onClick={() => go("/statuspage")}
          >
            {iconBell()}
            <span className="anav-status-dot" />
            {t(lang, "status")}
          </button>

          {/* จัดการห้อง dropdown */}
          <div className="anav-dropdown-wrap" ref={dropRef}>
            <button
              className={`anav-btn ${isRoomGroup ? "room-active" : ""}`}
              onClick={() => setRoomOpen(p => !p)}
            >
              {iconGrid()} {t(lang, "manageRooms")}
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                style={{ transition: "transform .2s", transform: roomOpen ? "rotate(180deg)" : "none" }}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>

            {roomOpen && (
              <div className="anav-dropdown">
                {roomItems.map((item, i) => {
                  const showDivider = i === 3 || i === 6;
                  const extraClass =
                    item.path === "/admin/cancellations" ? "cancel-item" :
                    item.path === "/admin/payments"      ? "slip-item"   : "";
                  return (
                    <span key={item.path}>
                      {showDivider && <div className="anav-drop-divider" />}
                      <button
                        className={`anav-drop-item ${extraClass} ${isActive(item.path) ? "active" : ""}`}
                        onClick={() => { go(item.path); setRoomOpen(false); }}
                      >
                        {item.icon} {t(lang, item.labelKey)}
                      </button>
                    </span>
                  );
                })}
              </div>
            )}
          </div>

          {/* จัดการสมาชิก */}
          <button
            className={`anav-btn ${isActive("/admin/users") ? "active" : ""}`}
            onClick={() => go("/admin/users")}
          >
            {iconUser()} {t(lang, "manageMembers")}
          </button>

          {/* แก้ไขใบเสร็จ dropdown */}
          <div className="anav-dropdown-wrap" ref={receiptDropRef}>
            <button
              className={`anav-btn ${["/admin/receipt", "/admin/receipt-archive", "/admin/items", "/admin/payment-settings"].includes(location.pathname) ? "room-active" : ""}`}
              onClick={() => setReceiptOpen(p => !p)}
            >
              {iconEdit()} {t(lang, "editReceipt")}
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                style={{ transition: "transform .2s", transform: receiptOpen ? "rotate(180deg)" : "none" }}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>

            {receiptOpen && (
              <div className="anav-dropdown">
                <button
                  className={`anav-drop-item ${isActive("/admin/receipt") ? "active" : ""}`}
                  onClick={() => { go("/admin/receipt"); setReceiptOpen(false); }}
                >
                  {iconEdit()} {t(lang, "editReceipt")}
                </button>
                <button
                  className={`anav-drop-item ${isActive("/admin/receipt-archive") ? "active" : ""}`}
                  onClick={() => { go("/admin/receipt-archive"); setReceiptOpen(false); }}
                >
                  {iconChart()} {t(lang, "receiptArchive")}
                </button>
                <button
                  className={`anav-drop-item ${isActive("/admin/items") ? "active" : ""}`}
                  onClick={() => { go("/admin/items"); setReceiptOpen(false); }}
                >
                  {iconTag()} {t(lang, "editItems")}
                </button>
                <button
                  className={`anav-drop-item ${isActive("/admin/payment-settings") ? "active" : ""}`}
                  onClick={() => { go("/admin/payment-settings"); setReceiptOpen(false); }}
                >
                  {iconQR()} {t(lang, "editPaymentSettings")}
                </button>
              </div>
            )}
          </div>

          {/* สร้างรายงาน dropdown — รวมรายงานการเข้าพัก + ทะเบียนลูกค้า */}
          <div className="anav-dropdown-wrap" ref={reportDropRef}>
            <button
              className={`anav-btn ${["/admin/report", "/admin/guests"].includes(location.pathname) ? "room-active" : ""}`}
              onClick={() => setReportOpen(p => !p)}
            >
              {iconChart()} {t(lang, "report")}
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                style={{ transition: "transform .2s", transform: reportOpen ? "rotate(180deg)" : "none" }}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>

            {reportOpen && (
              <div className="anav-dropdown">
                <button
                  className={`anav-drop-item ${isActive("/admin/report") ? "active" : ""}`}
                  onClick={() => { go("/admin/report"); setReportOpen(false); }}
                >
                  {iconChart()} {t(lang, "report")}
                </button>
                <button
                  className={`anav-drop-item ${isActive("/admin/guests") ? "active" : ""}`}
                  onClick={() => { go("/admin/guests"); setReportOpen(false); }}
                >
                  {iconGuests()} {t(lang, "grTitle")}
                </button>
              </div>
            )}
          </div>

          {/* Language dropdown */}
          <LangDropdown />

          {/* Logout */}
          <button className="anav-logout" onClick={handleLogout}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            {t(lang, "logout")}
          </button>
        </div>
      </nav>
    </>
  );
}

/* ── Icons ── */
function iconHome() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
}
function iconGrid() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
}
function iconBed() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 4v16"/><path d="M2 8h18a2 2 0 0 1 2 2v10"/><path d="M2 17h20"/><path d="M6 8v9"/></svg>;
}
function iconList() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;
}
function iconBan() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>;
}
function iconIn() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>;
}
function iconOut() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>;
}
function iconUser() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
}
function iconGuests() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
}
function iconEdit() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
}
function iconChart() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>;
}
function iconSlip() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="12" y2="17"/></svg>;
}
function iconTag() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>;
}
function iconQR() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><line x1="14" y1="14" x2="14" y2="17"/><line x1="14" y1="20" x2="14" y2="20.01"/><line x1="17" y1="14" x2="20" y2="14"/><line x1="20" y1="17" x2="17" y2="17"/><line x1="17" y1="20" x2="20" y2="20"/></svg>;
}
function iconBell() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
}

export { Navbar as NavbarAdmin };
export default Navbar;